import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Observable, throwError, from, BehaviorSubject } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { PublicRequestService } from 'src/app/services/public-request.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  // PREVENT MULTPLE SIMULATIONS OF TOKEN REFRESH

  private refreshInProgress = false;
  private refreshSubject = new BehaviorSubject<string | null>(null);

  constructor(private authService: AuthService, private translateService: TranslateService, private PublicRequestService: PublicRequestService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (this.PublicRequestService.isPublicRoute()) {
          return next.handle(req);
        }

        if (err.status === 401) {
          this.throwLogout();
        }
        return throwError(() => err);
      })
    );
  }

  private logoutInProgress = false;

  throwLogout() {
    if (this.logoutInProgress) return;
    this.logoutInProgress = true;

    alert(this.translateService.instant('SESSION_EXPIRED'));
    setTimeout(() => {
      this.authService.logout();
      this.logoutInProgress = false;
    }, 0);
  }
}